
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retail/home/confirmation",
      function () {
        return require("private-next-pages/retail/home/confirmation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/retail/home/confirmation"])
      });
    }
  